import React from 'react'
import {omit, mapValues} from 'lodash'

export default function useValidations(validations) {
  const [errors, setErrors] = React.useState(mapValues(validations, () => ''))
  const errorCount = Object.values(errors).filter(e => e.length > 0).length

  function validate (state) {
    let valid = true
    const validationResults = mapValues(validations, checks => {
      const error = checks.map(validation => validation(state)).find(result => result.length > 0)
      valid = valid && (error == undefined)
      return error || ''
    })
    setErrors({...validationResults})
    return valid
  }

  function resetErrors () {
    setErrors({...mapValues(validations, () => '')})
  }

  return {errors, errorCount, validate, resetErrors}

}
